import { render, staticRenderFns } from "./DetailPrivilege.vue?vue&type=template&id=60bed615&scoped=true"
import script from "./DetailPrivilege.vue?vue&type=script&lang=js"
export * from "./DetailPrivilege.vue?vue&type=script&lang=js"
import style0 from "./DetailPrivilege.vue?vue&type=style&index=0&id=60bed615&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bed615",
  null
  
)

export default component.exports